import { AuthScreen } from './base-auth-screen';

export class IntentAuthScreen extends AuthScreen {
  constructor(screen) {
    const formHandlerOptions = {
      arrayFields: ['intentions'],
    };

    super(screen, formHandlerOptions);
  }
}
